import { useMemo, useState } from "react"
import { QueryRender } from "@/components/helpers/QueryRender"
import { useYoungs } from "@/entities/user/useYoung"
import { Link } from "react-router-dom"
import { YoungsFilterSearchBar } from "@/components/filters/YoungsFilterSearchBar"
import { UserCard } from "@/components/ui/UserCard"

export default function YoungListPage() {
   const { data: youngs, ...query } = useYoungs()
   const [searchText, setSearchText] = useState("")
   const [selectedGroups, setSelectedGroups] = useState<string[]>([])

   const filteredYoungs = useMemo(
      () =>
         youngs
            ?.filter((young) => {
               const searchLower = searchText.toLowerCase()
               const matchesSearch =
                  young.firstName.toLowerCase().includes(searchLower) ||
                  young.lastName.toLowerCase().includes(searchLower)
               const matchesGroups =
                  selectedGroups.length === 0 || selectedGroups.includes(young.group)
               return matchesSearch && matchesGroups
            })
            .sort((a, b) => a.firstName.localeCompare(b.firstName)),
      [searchText, selectedGroups, youngs],
   )

   return (
      <div className="page-section">
         <h1 className="title">Liste des jeunes</h1>
         <div className="flex flex-col gap-6">
            <YoungsFilterSearchBar
               searchText={searchText}
               setSearchText={setSearchText}
               selectedGroups={selectedGroups}
               setSelectedGroups={setSelectedGroups}
            />

            <QueryRender query={query} data={filteredYoungs} emptyMessage="Aucun jeune trouvé">
               {(youngs) => (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                     {youngs.map((young) => (
                        <Link key={young.id} to={`/admin/resume-du-jeune/${young.id}`}>
                           <UserCard user={young} key={`user-card-${young.id}`}></UserCard>
                        </Link>
                     ))}
                  </div>
               )}
            </QueryRender>
         </div>
      </div>
   )
}
